/* eslint-disable */
import * as React from 'react';
import {
  Badge, Box, Button, Collapse, Divider, Flex, FormControl, FormLabel, HStack, Icon,
  IconButton, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter, ModalOverlay, Select, SimpleGrid, Stack, Table, Tbody, Td,
  Text, Th, Thead, Tooltip, Tr, useColorModeValue, useDisclosure, useToast,
} from '@chakra-ui/react';
import {
  ColumnFiltersState, PaginationState, createColumnHelper, flexRender,
  getCoreRowModel, getFacetedMinMaxValues, getFacetedRowModel, getFacetedUniqueValues,
  getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable,
} from '@tanstack/react-table';
import { useForm } from 'react-hook-form';
import { MdBusiness, MdCalendarToday, MdCancel, MdChevronLeft, MdChevronRight, MdDoneAll, MdEmail, MdFilterList, MdHome, MdPerson, MdPhone, MdRefresh, MdSearch, MdStorefront } from 'react-icons/md';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';

type RowObj = {
  id: number; RazonSocial: string; Nombre: string; ApellidoPaterno: string;
  ApellidoMaterno: string; RFC: string; CURP: string; Email: string; Telefono: string;
  Ocupacion: string; Genero: string; Nacimiento: string;
  Calle: string; Colonia: string; CodigoPostal: string; createdAt: string;
};

const inputStyles = {
  variant: 'filled' as const,
  borderRadius: 'lg',
  _focus: { bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' },
};

export default function SearchTableOrders(props: { tableData: any }) {
  const { tableData } = props;
  const toast = useToast();
  const filterBg = useColorModeValue('gray.50', 'navy.900');
  const textColor = useColorModeValue('navy.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const brandColor = useColorModeValue('brand.500', 'brand.400');
  const rowHover = useColorModeValue('gray.50', 'whiteAlpha.50');

  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();
  const { isOpen: isOpenDetalle, onOpen: onOpenDetalle, onClose: onCloseDetalle } = useDisclosure();
  const [selectedProveedor, setSelectedProveedor] = React.useState<RowObj | null>(null);
  const [showFilters, setShowFilters] = React.useState(false);
  const [fechaDesde, setFechaDesde] = React.useState('');
  const [fechaHasta, setFechaHasta] = React.useState('');

  const activeFilters = [!!(fechaDesde || fechaHasta)].filter(Boolean).length;
  const resetFilters = () => { setFechaDesde(''); setFechaHasta(''); };

  const [data, setData] = React.useState<RowObj[]>(() => [...tableData]);
  const [globalFilter, setGlobalFilter] = React.useState('');
  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>([]);
  const [{ pageIndex, pageSize }, setPagination] = React.useState<PaginationState>({ pageIndex: 0, pageSize: 8 });
  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);

  const filteredData = React.useMemo(() => data.filter((r) => {
    if (fechaDesde || fechaHasta) {
      const d = r.createdAt ? new Date(r.createdAt) : null;
      if (!d) return false;
      if (fechaDesde && d < new Date(fechaDesde)) return false;
      if (fechaHasta && d > new Date(fechaHasta + 'T23:59:59')) return false;
    }
    return true;
  }), [data, fechaDesde, fechaHasta]);

  const { handleSubmit, register, reset, formState: { isSubmitting } } = useForm();
  const generoOpts = [{ id: '1', valor: 'Femenino' }, { id: '2', valor: 'Masculino' }, { id: '3', valor: 'Sin Definir' }];

  const refreshTable = async () => {
    const d = await fetch(process.env.REACT_APP_URL_SERVER + '/proveedores', { credentials: 'include' }).then(r => r.json()).catch(() => null);
    if (d) setData(d);
  };

  const onSubmitNuevo = async (values: any) => {
    const fd = new FormData();
    for (const k in values) fd.append(k, values[k]);
    const res = await fetch(process.env.REACT_APP_URL_SERVER + '/new_provedor', { method: 'POST', body: fd, credentials: 'include' });
    if (res.ok) { toast({ title: 'Proveedor registrado', status: 'success', duration: 3000 }); reset(); onCloseNuevo(); await refreshTable(); }
    else toast({ title: 'Error al guardar', status: 'error', duration: 3000 });
  };

  const columnHelper = createColumnHelper<RowObj>();
  const columns = [
    columnHelper.accessor('RazonSocial', {
      id: 'razon',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">PROVEEDOR</Text>,
      cell: (info) => {
        const r = info.row.original;
        return <Box><Text color={textColor} fontWeight="600" fontSize="sm">{info.getValue() || `${r.Nombre} ${r.ApellidoPaterno}`}</Text><Text color="gray.400" fontSize="xs">{r.RFC}</Text></Box>;
      },
    }),
    columnHelper.accessor('Email', {
      id: 'email',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">EMAIL</Text>,
      cell: (info) => <Text color={textColor} fontSize="sm">{info.getValue()}</Text>,
    }),
    columnHelper.accessor('Telefono', {
      id: 'telefono',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">TELÉFONO</Text>,
      cell: (info) => <Flex align="center" gap="6px"><Icon as={MdPhone} h="14px" w="14px" color="gray.400" /><Text color={textColor} fontSize="sm"><a href={'tel:' + info.getValue()}>{info.getValue()}</a></Text></Flex>,
    }),
    columnHelper.accessor('createdAt', {
      id: 'registro',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">REGISTRO</Text>,
      cell: (info) => { const v = info.getValue(); return <Text color="gray.500" fontSize="xs">{v ? new Date(v).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}</Text>; },
    }),
    columnHelper.accessor('id', {
      id: 'actions',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">ACCIONES</Text>,
      cell: (info) => (
        <HStack spacing="2px">
          <Tooltip label="Ver detalle"><IconButton aria-label="detalle" size="sm" variant="ghost" colorScheme="brand" icon={<Icon as={MdSearch} h="18px" w="18px" />} onClick={() => { setSelectedProveedor(info.row.original); onOpenDetalle(); }} /></Tooltip>
          <Tooltip label="Aprobar"><IconButton aria-label="aprobar" size="sm" variant="ghost" colorScheme="green" icon={<Icon as={MdDoneAll} h="18px" w="18px" />} onClick={() => toast({ title: `Proveedor #${info.getValue()} aprobado`, status: 'success', duration: 2000 })} /></Tooltip>
          <Tooltip label="Eliminar"><IconButton aria-label="eliminar" size="sm" variant="ghost" colorScheme="red" icon={<Icon as={MdCancel} h="18px" w="18px" />} onClick={() => toast({ title: 'Acción no configurada', status: 'warning', duration: 2000 })} /></Tooltip>
        </HStack>
      ),
    }),
  ];

  const table = useReactTable({
    data: filteredData, columns,
    state: { columnFilters, globalFilter, pagination },
    onPaginationChange: setPagination, onColumnFiltersChange: setColumnFilters, onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(), getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(), getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(), getFacetedUniqueValues: getFacetedUniqueValues(), getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  const createPages = (n: number) => Array.from({ length: n }, (_, i) => i + 1);

  return (
    <Flex direction="column" w="100%" overflowX={{ sm: 'scroll', lg: 'hidden' }}>
      <Flex align="center" justify="space-between" w="100%" px="22px" mb="16px" flexWrap="wrap" gap="10px">
        <DebouncedInput value={globalFilter ?? ''} onChange={(v) => setGlobalFilter(String(v))} placeholder="Buscar proveedor..." />
        <HStack spacing="8px">
          <Tooltip label="Actualizar"><IconButton aria-label="refresh" size="md" variant="outline" icon={<Icon as={MdRefresh} h="18px" w="18px" />} onClick={refreshTable} /></Tooltip>
          <Button variant="outline" fontSize="sm" leftIcon={<Icon as={MdFilterList} />} onClick={() => setShowFilters(v => !v)} position="relative">
            Filtros{activeFilters > 0 && <Badge colorScheme="brand" borderRadius="full" position="absolute" top="-6px" right="-6px" fontSize="10px" minW="18px" h="18px" display="flex" alignItems="center" justifyContent="center">{activeFilters}</Badge>}
          </Button>
          <Button variant="brand" fontSize="sm" fontWeight="500" onClick={onOpenNuevo}>+ Nuevo Proveedor</Button>
        </HStack>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Box mx="22px" mb="16px" p="16px" bg={filterBg} borderRadius="12px" border="1px solid" borderColor={borderColor}>
          <Text fontSize="sm" fontWeight="700" color={textColor} mb="14px">Filtros avanzados</Text>
          <Box>
            <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">FECHA DE REGISTRO</FormLabel>
            <HStack spacing="8px">
              <Input size="sm" type="date" borderRadius="8px" value={fechaDesde} onChange={(e) => { setFechaDesde(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
              <Text fontSize="xs" color="gray.400">al</Text>
              <Input size="sm" type="date" borderRadius="8px" value={fechaHasta} onChange={(e) => { setFechaHasta(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
            </HStack>
          </Box>
          <Flex mt="14px" justify="flex-end"><Button size="sm" variant="ghost" colorScheme="red" onClick={resetFilters}>Limpiar</Button></Flex>
        </Box>
      </Collapse>
      {activeFilters > 0 && <Text px="22px" mb="8px" fontSize="xs" color="gray.500">Mostrando <strong>{filteredData.length}</strong> de {data.length}</Text>}

      {/* Nuevo proveedor modal */}
      <Modal isOpen={isOpenNuevo} onClose={() => { reset(); onCloseNuevo(); }} size="4xl" scrollBehavior="inside" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
        <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>

          {/* Header */}
          <Box bg="brand.500" px={6} py={4}>
            <HStack justify="space-between" align="center">
              <HStack gap={3}>
                <Icon as={MdStorefront} color="white" w={5} h={5} />
                <Text color="white" fontWeight="700" fontSize="lg">Registrar Nuevo Proveedor</Text>
              </HStack>
              <ModalCloseButton position="static" color="white" _hover={{ bg: 'whiteAlpha.300' }} borderRadius="lg" />
            </HStack>
          </Box>

          <form onSubmit={handleSubmit(onSubmitNuevo)}>
            <ModalBody px={6} py={6}>

              {/* Sección: Datos de la Empresa */}
              <HStack mb={3}>
                <Icon as={MdBusiness} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">
                  Datos de la Empresa
                </Text>
                <Divider />
              </HStack>

              <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} mb={5}>
                <FField label="Razón Social">
                  <InputGroup>
                    <Input placeholder="Empresa S.A. de C.V." {...register('RazonSocial')} {...inputStyles} />
                    <InputRightElement pointerEvents="none">
                      <Icon as={MdBusiness} color="gray.400" />
                    </InputRightElement>
                  </InputGroup>
                </FField>
                <FField label="RFC">
                  <Input placeholder="TORJ800101AAA" {...register('RFC')} {...inputStyles} />
                </FField>
                <FField label="Ocupación / Giro">
                  <Input placeholder="Servicios Gráficos" {...register('Ocupacion')} {...inputStyles} />
                </FField>
                <FField label="CURP">
                  <Input placeholder="TORJ800101HJCRRM09" {...register('CURP')} {...inputStyles} />
                </FField>
              </SimpleGrid>

              {/* Sección: Datos del Contacto */}
              <HStack mb={3}>
                <Icon as={MdPerson} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">
                  Datos del Contacto
                </Text>
                <Divider />
              </HStack>

              <SimpleGrid columns={{ base: 1, md: 3 }} gap={4} mb={5}>
                <FField label="Nombre">
                  <Input placeholder="Juan" {...register('Nombre')} {...inputStyles} />
                </FField>
                <FField label="Apellido Paterno">
                  <Input placeholder="Torres" {...register('ApellidoPaterno')} {...inputStyles} />
                </FField>
                <FField label="Apellido Materno">
                  <Input placeholder="García" {...register('ApellidoMaterno')} {...inputStyles} />
                </FField>
                <FField label="Teléfono">
                  <InputGroup>
                    <Input type="tel" placeholder="3312345678" {...register('Telefono')} {...inputStyles} />
                    <InputRightElement pointerEvents="none">
                      <Icon as={MdPhone} color="gray.400" />
                    </InputRightElement>
                  </InputGroup>
                </FField>
                <FField label="Email">
                  <InputGroup>
                    <Input type="email" placeholder="proveedor@empresa.com" {...register('Email')} {...inputStyles} />
                    <InputRightElement pointerEvents="none">
                      <Icon as={MdEmail} color="gray.400" />
                    </InputRightElement>
                  </InputGroup>
                </FField>
                <FField label="Género">
                  <Select {...register('Genero')} {...inputStyles}>
                    <option value="">Seleccionar</option>
                    <option value="1">Femenino</option>
                    <option value="2">Masculino</option>
                    <option value="3">Sin Definir</option>
                  </Select>
                </FField>
                <FField label="Fecha de Nacimiento">
                  <InputGroup>
                    <Input type="date" {...register('Nacimiento')} {...inputStyles} />
                    <InputRightElement pointerEvents="none">
                      <Icon as={MdCalendarToday} color="gray.400" />
                    </InputRightElement>
                  </InputGroup>
                </FField>
              </SimpleGrid>

              {/* Sección: Domicilio */}
              <HStack mb={3}>
                <Icon as={MdHome} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">
                  Domicilio
                </Text>
                <Divider />
              </HStack>

              <SimpleGrid columns={{ base: 1, md: 3 }} gap={4}>
                <FField label="Calle">
                  <Input placeholder="Av. Industriales 45" {...register('Calle')} {...inputStyles} />
                </FField>
                <FField label="Colonia">
                  <Input placeholder="Industrial Norte" {...register('Colonia')} {...inputStyles} />
                </FField>
                <FField label="Código Postal">
                  <Input type="number" placeholder="44500" {...register('CodigoPostal')} {...inputStyles} />
                </FField>
              </SimpleGrid>

            </ModalBody>
            <ModalFooter borderTop="1px solid" borderColor="gray.100" gap={3} px={6} py={4}>
              <Button variant="ghost" borderRadius="xl" onClick={() => { reset(); onCloseNuevo(); }}>
                Cancelar
              </Button>
              <Button colorScheme="brand" type="submit" isLoading={isSubmitting} borderRadius="xl" px={8}
                leftIcon={<Icon as={MdStorefront} />}>
                Registrar Proveedor
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      {/* Detalle proveedor modal */}
      {selectedProveedor && (
        <Modal isOpen={isOpenDetalle} onClose={onCloseDetalle} size="3xl" scrollBehavior="inside" motionPreset="slideInBottom">
          <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
          <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>

            {/* Header */}
            <Box bg="brand.500" px={6} py={4}>
              <HStack justify="space-between" align="center">
                <HStack gap={3}>
                  <Icon as={MdStorefront} color="white" w={5} h={5} />
                  <Box>
                    <Text color="white" fontWeight="700" fontSize="lg" lineHeight="1.2">
                      {selectedProveedor.RazonSocial || `${selectedProveedor.Nombre} ${selectedProveedor.ApellidoPaterno}`}
                    </Text>
                    <Text color="whiteAlpha.800" fontSize="sm">{selectedProveedor.RFC || '—'}</Text>
                  </Box>
                </HStack>
                <ModalCloseButton position="static" color="white" _hover={{ bg: 'whiteAlpha.300' }} borderRadius="lg" />
              </HStack>
            </Box>

            <ModalBody px={6} py={6}>

              {/* Sección: Datos de la Empresa */}
              <HStack mb={3}>
                <Icon as={MdBusiness} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">Datos de la Empresa</Text>
                <Divider />
              </HStack>
              <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} mb={5}>
                <PField label="Razón Social" value={selectedProveedor.RazonSocial} />
                <PField label="RFC" value={selectedProveedor.RFC} />
                <PField label="CURP" value={selectedProveedor.CURP} />
                <PField label="Ocupación / Giro" value={selectedProveedor.Ocupacion} />
              </SimpleGrid>

              {/* Sección: Datos del Contacto */}
              <HStack mb={3}>
                <Icon as={MdPerson} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">Datos del Contacto</Text>
                <Divider />
              </HStack>
              <SimpleGrid columns={{ base: 1, md: 3 }} gap={4} mb={5}>
                <PField label="Nombre" value={selectedProveedor.Nombre} />
                <PField label="Apellido Paterno" value={selectedProveedor.ApellidoPaterno} />
                <PField label="Apellido Materno" value={selectedProveedor.ApellidoMaterno} />
                <PField label="Teléfono" value={selectedProveedor.Telefono} />
                <PField label="Email" value={selectedProveedor.Email} />
                <PField label="Género" value={selectedProveedor.Genero === '1' ? 'Femenino' : selectedProveedor.Genero === '2' ? 'Masculino' : selectedProveedor.Genero === '3' ? 'Sin Definir' : selectedProveedor.Genero} />
                <PField label="Fecha de Nacimiento" value={selectedProveedor.Nacimiento ? new Date(selectedProveedor.Nacimiento).toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' }) : undefined} />
                <PField label="Registro" value={selectedProveedor.createdAt ? new Date(selectedProveedor.createdAt).toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' }) : undefined} />
              </SimpleGrid>

              {/* Sección: Domicilio */}
              <HStack mb={3}>
                <Icon as={MdHome} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">Domicilio</Text>
                <Divider />
              </HStack>
              <SimpleGrid columns={{ base: 1, md: 3 }} gap={4}>
                <PField label="Calle" value={selectedProveedor.Calle} />
                <PField label="Colonia" value={selectedProveedor.Colonia} />
                <PField label="Código Postal" value={selectedProveedor.CodigoPostal} />
              </SimpleGrid>

            </ModalBody>
            <ModalFooter borderTop="1px solid" borderColor="gray.100" px={6} py={4}>
              <Button colorScheme="brand" borderRadius="xl" px={8} onClick={onCloseDetalle}>Cerrar</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      <Table variant="simple" color="gray.500" mb="24px">
        <Thead>{table.getHeaderGroups().map(hg => (<Tr key={hg.id}>{hg.headers.map(h => (<Th pe="10px" borderColor={borderColor} key={h.id} colSpan={h.colSpan}>{h.isPlaceholder ? null : (<Flex justify="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" cursor={h.column.getCanSort() ? 'pointer' : 'default'} onClick={h.column.getToggleSortingHandler()}>{flexRender(h.column.columnDef.header, h.getContext())}</Flex>)}</Th>))}</Tr>))}</Thead>
        <Tbody>
          {table.getRowModel().rows.length === 0 ? (<Tr><Td colSpan={columns.length} textAlign="center" py="40px" color="gray.400">Sin registros</Td></Tr>) :
            table.getRowModel().rows.map(row => (<Tr key={row.id} _hover={{ bg: rowHover }}>{row.getVisibleCells().map(cell => (<Td key={cell.id} fontSize={{ sm: '14px' }} minW={{ sm: '120px', md: 'auto' }} borderColor={borderColor} py="12px">{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>))}</Tr>))}
        </Tbody>
      </Table>
      <Flex w="100%" justify="space-between" px="20px" pt="10px" pb="5px">
        <Text fontSize="sm" color="gray.500" mb={{ sm: '24px', md: '0px' }}>{filteredData.length === 0 ? 'Sin registros' : `${pageSize * pageIndex + 1}–${Math.min(pageSize * (pageIndex + 1), filteredData.length)} de ${filteredData.length}`}</Text>
        <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
          <Button variant="no-effects" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()} w="40px" h="40px" borderRadius="50%" bg="transparent" border="1px solid" borderColor={borderColor} display={table.getCanPreviousPage() ? 'flex' : 'none'} _hover={{ opacity: '0.7' }}><Icon as={MdChevronLeft} w="16px" h="16px" color={textColor} /></Button>
          {createPages(table.getPageCount()).map((p, i) => (<Button key={i} variant="no-effects" onClick={() => table.setPageIndex(p - 1)} w="40px" h="40px" borderRadius="50%" bg={p === pageIndex + 1 ? brandColor : 'transparent'} border={p === pageIndex + 1 ? 'none' : '1px solid lightgray'} _hover={p === pageIndex + 1 ? { opacity: '0.7' } : { bg: 'whiteAlpha.100' }}><Text fontSize="sm" color={p === pageIndex + 1 ? '#fff' : textColor}>{p}</Text></Button>))}
          <Button variant="no-effects" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()} w="40px" h="40px" borderRadius="50%" bg="transparent" border="1px solid" borderColor={borderColor} display={table.getCanNextPage() ? 'flex' : 'none'} _hover={{ opacity: '0.7' }}><Icon as={MdChevronRight} w="16px" h="16px" color={textColor} /></Button>
        </Stack>
      </Flex>
    </Flex>
  );
}

function PField({ label, value }: { label: string; value?: string | null }) {
  const textColor = useColorModeValue('navy.700', 'white');
  return (
    <Box>
      <Text fontSize="10px" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.400" mb="2px">{label}</Text>
      <Text fontSize="sm" fontWeight="500" color={value ? textColor : 'gray.300'}>{value || '—'}</Text>
    </Box>
  );
}

function FField({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <FormControl>
      <FormLabel fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.500" mb={1}>{label}</FormLabel>
      {children}
    </FormControl>
  );
}

function DebouncedInput({ value: iv, onChange, debounce = 500, ...props }: { value: string | number; onChange: (v: string | number) => void; debounce?: number } & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = React.useState(iv);
  React.useEffect(() => { setValue(iv); }, [iv]);
  React.useEffect(() => { const t = setTimeout(() => onChange(value), debounce); return () => clearTimeout(t); }, [value]);
  return <SearchBar {...props} value={value} onChange={(e: any) => setValue(e.target.value)} h="44px" w={{ lg: '390px' }} borderRadius="16px" />;
}
